/* Team Work PWA — enregistrement limité à la production pour éviter de mettre en cache le serveur de développement. */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    navigator.serviceWorker.register(`${publicUrl}/service-worker.js`, { scope: "/" }).catch(() => {
      // La plateforme reste utilisable sans service worker si le navigateur le bloque.
    });
  });
}
